<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "UnternehmenspraesentationList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Unternehmenspräsentation"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category=2
      :event-to-call-options="{
        table: tableItems,
        showPath: 'Unternehmenspraesentation',
        redirectPath: 'UnternehmenspraesentationEdit',
        categoryId: 2,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'einarbeitung'
      }"
   new-button-path="UnternehmenspraesentationNew"></CMSListCard>
</template>

<style scoped>

</style>
